import {
  BodyText,
  DialogContent,
  ModalFooter,
  ModalHeader,
  NextDialog,
} from '@cint/wonderment';
import { ReactNode } from 'react';

interface Props {
  isOpen: boolean;
  title: string;
  description: ReactNode;
  onDelete: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  primaryButtonText?: string;
}

export const DeleteDialog = ({
  isOpen,
  title,
  description,
  onDelete,
  onCancel,
  isLoading,
  primaryButtonText = 'Delete',
}: Props) => {
  return (
    <NextDialog open={isOpen}>
      <DialogContent>
        <ModalHeader title={title} isDismissible={false} />
        <BodyText className="ds-mt-2 ds-mb-6">{description}</BodyText>
        <ModalFooter
          isDanger={true}
          primaryButtonProps={{
            text: primaryButtonText,
            onClick: onDelete,
            isDisabled: isLoading,
          }}
          secondaryButtonProps={{
            text: 'Cancel',
            onClick: onCancel,
            isDisabled: isLoading,
          }}
        />
      </DialogContent>
    </NextDialog>
  );
};
